/**
 * Returns the correct API base URL.
 * 
 * On production domains (soulsanskar.com / soulsanskar.in) → uses same-origin
 * to avoid CORS issues from stale REACT_APP_BACKEND_URL values.
 * 
 * On preview/development → uses REACT_APP_BACKEND_URL env variable.
 */
export function getApiUrl() {
  const currentOrigin = window.location.origin;

  if (
    currentOrigin.includes('soulsanskar.com') ||
    currentOrigin.includes('soulsanskar.in')
  ) {
    return currentOrigin;
  }

  return process.env.REACT_APP_BACKEND_URL || '';
}
